import React, { useState } from 'react';
import { Section } from './Section';
import { Sparkles, Flame, Heart, Play, CheckCircle, Clock, Lock, ChevronRight } from 'lucide-react';
interface CollectionItem {
  id: string;
  type: 'skin' | 'boost' | 'fanclub' | 'content';
  title: string;
  description?: string;
  rarity?: 'common' | 'rare' | 'epic' | 'legendary';
  status: 'owned' | 'equipped' | 'active' | 'inactive' | 'not_owned' | 'locked';
  thumbnail?: string;
  angelName?: string;
  duration?: string;
  expiresIn?: string;
}
export const Collections: React.FC = () => {
  const [activeCategory, setActiveCategory] = useState<string>('skins');
  const [skinFilter, setSkinFilter] = useState<string>('owned');
  const [boostFilter, setBoostFilter] = useState<string>('all');
  const collectionItems: CollectionItem[] = [
  // Skins
  {
    id: 'skin-1',
    type: 'skin',
    title: 'Beachside Beauty',
    rarity: 'epic',
    status: 'equipped',
    angelName: 'Sophia',
    thumbnail: 'https://images.unsplash.com/photo-1583900985737-6d0495555783?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80'
  }, {
    id: 'skin-2',
    type: 'skin',
    title: 'Midnight Glow',
    rarity: 'rare',
    status: 'owned',
    angelName: 'Harper',
    thumbnail: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80'
  }, {
    id: 'skin-3',
    type: 'skin',
    title: 'Neon Dreams',
    rarity: 'legendary',
    status: 'owned',
    angelName: 'Zoey',
    thumbnail: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80'
  }, {
    id: 'skin-4',
    type: 'skin',
    title: 'Starlight Angel',
    rarity: 'epic',
    status: 'not_owned',
    angelName: 'Sophia',
    thumbnail: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80'
  }, {
    id: 'skin-5',
    type: 'skin',
    title: 'Limited Edition Summer',
    rarity: 'legendary',
    status: 'locked',
    angelName: 'Mia Khalifa',
    thumbnail: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80'
  },
  // Boosts
  {
    id: 'boost-1',
    type: 'boost',
    title: '2x Token Earnings',
    description: 'Earn double tokens from all activities',
    status: 'active',
    duration: '24h',
    expiresIn: '18h 45m'
  }, {
    id: 'boost-2',
    type: 'boost',
    title: 'VIP Status',
    description: 'Access to VIP areas and content',
    status: 'active',
    duration: '7 days',
    expiresIn: '3d 12h'
  }, {
    id: 'boost-3',
    type: 'boost',
    title: '50% XP Boost',
    description: 'Earn 50% more XP from all activities',
    status: 'inactive',
    duration: '48h'
  }, {
    id: 'boost-4',
    type: 'boost',
    title: 'Priority Chat',
    description: 'Get priority in angel chat queues',
    status: 'inactive',
    duration: '24h'
  },
  // Fan Clubs
  {
    id: 'fanclub-1',
    type: 'fanclub',
    title: "Sophia's Inner Circle",
    status: 'owned',
    angelName: 'Sophia',
    thumbnail: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80'
  }, {
    id: 'fanclub-2',
    type: 'fanclub',
    title: "Harper's Hotties",
    status: 'owned',
    angelName: 'Harper',
    thumbnail: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80'
  }, {
    id: 'fanclub-3',
    type: 'fanclub',
    title: "Zoey's Secret Society",
    status: 'not_owned',
    angelName: 'Zoey',
    thumbnail: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80'
  },
  // Premium Content
  {
    id: 'content-1',
    type: 'content',
    title: 'Summer Photoshoot',
    status: 'owned',
    angelName: 'Sophia',
    thumbnail: 'https://images.unsplash.com/photo-1583900985737-6d0495555783?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80'
  }, {
    id: 'content-2',
    type: 'content',
    title: 'Behind the Scenes',
    status: 'owned',
    angelName: 'Harper',
    thumbnail: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80'
  }, {
    id: 'content-3',
    type: 'content',
    title: 'Exclusive Interview',
    status: 'owned',
    angelName: 'Mia Khalifa',
    thumbnail: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80'
  }];
  const getFilteredItems = () => {
    let filtered = collectionItems.filter(item => item.type === activeCategory);
    if (activeCategory === 'skins') {
      if (skinFilter === 'owned') {
        filtered = filtered.filter(item => item.status === 'owned' || item.status === 'equipped');
      } else if (skinFilter === 'not_owned') {
        filtered = filtered.filter(item => item.status === 'not_owned' || item.status === 'locked');
      } else if (skinFilter === 'limited') {
        filtered = filtered.filter(item => item.rarity === 'legendary');
      }
    } else if (activeCategory === 'boosts') {
      if (boostFilter === 'active') {
        filtered = filtered.filter(item => item.status === 'active');
      } else if (boostFilter === 'inactive') {
        filtered = filtered.filter(item => item.status === 'inactive');
      }
    }
    return filtered;
  };
  const getRarityColor = (rarity?: string) => {
    switch (rarity) {
      case 'common':
        return 'from-gray-400 to-gray-500';
      case 'rare':
        return 'from-blue-400 to-blue-500';
      case 'epic':
        return 'from-purple-400 to-purple-500';
      case 'legendary':
        return 'from-amber-400 to-amber-500';
      default:
        return 'from-gray-400 to-gray-500';
    }
  };
  const getRarityTextColor = (rarity?: string) => {
    switch (rarity) {
      case 'common':
        return 'text-gray-700 dark:text-gray-300';
      case 'rare':
        return 'text-blue-700 dark:text-blue-300';
      case 'epic':
        return 'text-purple-700 dark:text-purple-300';
      case 'legendary':
        return 'text-amber-700 dark:text-amber-300';
      default:
        return 'text-gray-700 dark:text-gray-300';
    }
  };
  const getStatusBadge = (item: CollectionItem) => {
    switch (item.status) {
      case 'equipped':
        return <span className="absolute top-2 right-2 bg-gradient-to-r from-green-500 to-emerald-500 text-white text-xs px-2 py-0.5 rounded-full flex items-center gap-1 shadow-[0_0_10px_rgba(16,185,129,0.3)] z-20" data-id="element-23404">
            <CheckCircle size={10} data-id="element-23405" />
            Equipped
          </span>;
      case 'active':
        return <span className="absolute top-2 right-2 bg-gradient-to-r from-green-500 to-emerald-500 text-white text-xs px-2 py-0.5 rounded-full flex items-center gap-1 shadow-[0_0_10px_rgba(16,185,129,0.3)] z-20" data-id="element-23406">
            <Flame size={10} data-id="element-23407" />
            Active
          </span>;
      case 'not_owned':
        return <span className="absolute top-2 right-2 bg-gradient-to-r from-gray-500 to-gray-600 text-white text-xs px-2 py-0.5 rounded-full z-20" data-id="element-23408">
            Not Owned
          </span>;
      case 'locked':
        return <span className="absolute top-2 right-2 bg-gradient-to-r from-amber-500 to-orange-500 text-white text-xs px-2 py-0.5 rounded-full flex items-center gap-1 shadow-[0_0_10px_rgba(245,158,11,0.3)] z-20" data-id="element-23409">
            <Lock size={10} data-id="element-23410" />
            Locked
          </span>;
      default:
        return null;
    }
  };
  const getActionButton = (item: CollectionItem) => {
    switch (item.type) {
      case 'skin':
        if (item.status === 'equipped') {
          return <button className="w-full mt-2 px-3 py-1.5 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-lg text-xs font-medium" data-id="element-23411">
              Equipped
            </button>;
        } else if (item.status === 'owned') {
          return <button className="w-full mt-2 px-3 py-1.5 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-lg text-xs font-medium hover:shadow-sm transition-all" data-id="element-23412">
              Equip
            </button>;
        } else if (item.status === 'not_owned') {
          return <button className="w-full mt-2 px-3 py-1.5 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg text-xs font-medium hover:shadow-sm transition-all" data-id="element-23413">
              Purchase
            </button>;
        } else if (item.status === 'locked') {
          return <button className="w-full mt-2 px-3 py-1.5 bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-lg text-xs font-medium hover:shadow-sm transition-all" data-id="element-23414">
              Unlock
            </button>;
        }
        break;
      case 'boost':
        if (item.status === 'active') {
          return <div className="w-full mt-2 flex items-center justify-between" data-id="element-23415">
              <span className="text-xs text-gray-600 dark:text-gray-400 flex items-center gap-1" data-id="element-23416">
                <Clock size={12} data-id="element-23417" />
                {item.expiresIn}
              </span>
              <button className="px-3 py-1 bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400 rounded-lg text-xs font-medium hover:bg-red-200 dark:hover:bg-red-800/30 transition-colors" data-id="element-23418">
                Cancel
              </button>
            </div>;
        } else if (item.status === 'inactive') {
          return <button className="w-full mt-2 px-3 py-1.5 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg text-xs font-medium hover:shadow-sm transition-all" data-id="element-23419">
              Activate
            </button>;
        }
        break;
      case 'fanclub':
        if (item.status === 'owned') {
          return <button className="w-full mt-2 px-3 py-1.5 bg-gradient-to-r from-pink-500 to-purple-600 text-white rounded-lg text-xs font-medium hover:shadow-sm transition-all flex items-center justify-center gap-1" data-id="element-23420">
              <Heart size={12} data-id="element-23421" />
              <span data-id="element-23422">Visit Fan Club</span>
            </button>;
        } else {
          return <button className="w-full mt-2 px-3 py-1.5 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg text-xs font-medium hover:shadow-sm transition-all" data-id="element-23423">
              Join Club
            </button>;
        }
      case 'content':
        return <button className="w-full mt-2 px-3 py-1.5 bg-gradient-to-r from-purple-500 to-pink-600 text-white rounded-lg text-xs font-medium hover:shadow-sm transition-all flex items-center justify-center gap-1" data-id="element-23424">
            <Play size={12} data-id="element-23425" />
            <span data-id="element-23426">View Content</span>
          </button>;
      default:
        return null;
    }
  };
  return <div className="space-y-4" data-id="element-23427">
      <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide" data-id="element-23428">
        <button className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 flex items-center gap-1.5 relative overflow-hidden ${activeCategory === 'skins' ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-[0_0_15px_rgba(168,85,247,0.3)]' : 'bg-white/70 dark:bg-gray-800/70 text-gray-700 dark:text-gray-300 hover:bg-white dark:hover:bg-gray-700 backdrop-blur-sm'}`} onClick={() => setActiveCategory('skins')} data-id="element-23429">
          {/* Button background pattern */}
          <div className={`absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/diamond-upholstery.png')] opacity-10 ${activeCategory === 'skins' ? 'visible' : 'invisible'}`} data-id="element-23430"></div>
          {/* Button hover effect */}
          {activeCategory === 'skins' && <div className="absolute inset-0 bg-white/20 opacity-0 hover:opacity-100 transition-opacity duration-300" data-id="element-23431"></div>}
          <Sparkles size={16} className="relative z-10" data-id="element-23432" />
          <span className="relative z-10" data-id="element-23433">Angel Skins</span>
        </button>
        <button className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 flex items-center gap-1.5 relative overflow-hidden ${activeCategory === 'boosts' ? 'bg-gradient-to-r from-blue-600 to-cyan-600 text-white shadow-[0_0_15px_rgba(59,130,246,0.3)]' : 'bg-white/70 dark:bg-gray-800/70 text-gray-700 dark:text-gray-300 hover:bg-white dark:hover:bg-gray-700 backdrop-blur-sm'}`} onClick={() => setActiveCategory('boosts')} data-id="element-23434">
          {/* Button background pattern */}
          <div className={`absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/diamond-upholstery.png')] opacity-10 ${activeCategory === 'boosts' ? 'visible' : 'invisible'}`} data-id="element-23435"></div>
          {/* Button hover effect */}
          {activeCategory === 'boosts' && <div className="absolute inset-0 bg-white/20 opacity-0 hover:opacity-100 transition-opacity duration-300" data-id="element-23436"></div>}
          <Flame size={16} className="relative z-10" data-id="element-23437" />
          <span className="relative z-10" data-id="element-23438">Boosts & Perks</span>
        </button>
        <button className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 flex items-center gap-1.5 relative overflow-hidden ${activeCategory === 'fanclub' ? 'bg-gradient-to-r from-pink-600 to-red-600 text-white shadow-[0_0_15px_rgba(236,72,153,0.3)]' : 'bg-white/70 dark:bg-gray-800/70 text-gray-700 dark:text-gray-300 hover:bg-white dark:hover:bg-gray-700 backdrop-blur-sm'}`} onClick={() => setActiveCategory('fanclub')} data-id="element-23439">
          {/* Button background pattern */}
          <div className={`absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/diamond-upholstery.png')] opacity-10 ${activeCategory === 'fanclub' ? 'visible' : 'invisible'}`} data-id="element-23440"></div>
          {/* Button hover effect */}
          {activeCategory === 'fanclub' && <div className="absolute inset-0 bg-white/20 opacity-0 hover:opacity-100 transition-opacity duration-300" data-id="element-23441"></div>}
          <Heart size={16} className="relative z-10" data-id="element-23442" />
          <span className="relative z-10" data-id="element-23443">Fan Clubs</span>
        </button>
        <button className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 flex items-center gap-1.5 relative overflow-hidden ${activeCategory === 'content' ? 'bg-gradient-to-r from-amber-600 to-orange-600 text-white shadow-[0_0_15px_rgba(245,158,11,0.3)]' : 'bg-white/70 dark:bg-gray-800/70 text-gray-700 dark:text-gray-300 hover:bg-white dark:hover:bg-gray-700 backdrop-blur-sm'}`} onClick={() => setActiveCategory('content')} data-id="element-23444">
          {/* Button background pattern */}
          <div className={`absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/diamond-upholstery.png')] opacity-10 ${activeCategory === 'content' ? 'visible' : 'invisible'}`} data-id="element-23445"></div>
          {/* Button hover effect */}
          {activeCategory === 'content' && <div className="absolute inset-0 bg-white/20 opacity-0 hover:opacity-100 transition-opacity duration-300" data-id="element-23446"></div>}
          <Play size={16} className="relative z-10" data-id="element-23447" />
          <span className="relative z-10" data-id="element-23448">Premium Content</span>
        </button>
      </div>
      {/* Secondary filters based on active category */}
      {activeCategory === 'skins' && <div className="flex items-center gap-2 mb-2" data-id="element-23449">
          <button className={`px-3 py-1 rounded-full text-xs font-medium transition-all ${skinFilter === 'owned' ? 'bg-gradient-to-r from-gray-800 to-gray-700 dark:from-gray-700 dark:to-gray-600 text-white shadow-[0_0_10px_rgba(75,85,99,0.3)]' : 'bg-white/70 dark:bg-gray-800/70 text-gray-700 dark:text-gray-300 backdrop-blur-sm'}`} onClick={() => setSkinFilter('owned')} data-id="element-23450">
            Owned
          </button>
          <button className={`px-3 py-1 rounded-full text-xs font-medium transition-all ${skinFilter === 'not_owned' ? 'bg-gradient-to-r from-gray-800 to-gray-700 dark:from-gray-700 dark:to-gray-600 text-white shadow-[0_0_10px_rgba(75,85,99,0.3)]' : 'bg-white/70 dark:bg-gray-800/70 text-gray-700 dark:text-gray-300 backdrop-blur-sm'}`} onClick={() => setSkinFilter('not_owned')} data-id="element-23451">
            Not Owned
          </button>
          <button className={`px-3 py-1 rounded-full text-xs font-medium transition-all ${skinFilter === 'limited' ? 'bg-gradient-to-r from-gray-800 to-gray-700 dark:from-gray-700 dark:to-gray-600 text-white shadow-[0_0_10px_rgba(75,85,99,0.3)]' : 'bg-white/70 dark:bg-gray-800/70 text-gray-700 dark:text-gray-300 backdrop-blur-sm'}`} onClick={() => setSkinFilter('limited')} data-id="element-23452">
            Limited Edition
          </button>
        </div>}
      {activeCategory === 'boosts' && <div className="flex items-center gap-2 mb-2" data-id="element-23453">
          <button className={`px-3 py-1 rounded-full text-xs font-medium transition-all ${boostFilter === 'all' ? 'bg-gradient-to-r from-gray-800 to-gray-700 dark:from-gray-700 dark:to-gray-600 text-white shadow-[0_0_10px_rgba(75,85,99,0.3)]' : 'bg-white/70 dark:bg-gray-800/70 text-gray-700 dark:text-gray-300 backdrop-blur-sm'}`} onClick={() => setBoostFilter('all')} data-id="element-23454">
            All
          </button>
          <button className={`px-3 py-1 rounded-full text-xs font-medium transition-all ${boostFilter === 'active' ? 'bg-gradient-to-r from-gray-800 to-gray-700 dark:from-gray-700 dark:to-gray-600 text-white shadow-[0_0_10px_rgba(75,85,99,0.3)]' : 'bg-white/70 dark:bg-gray-800/70 text-gray-700 dark:text-gray-300 backdrop-blur-sm'}`} onClick={() => setBoostFilter('active')} data-id="element-23455">
            Active
          </button>
          <button className={`px-3 py-1 rounded-full text-xs font-medium transition-all ${boostFilter === 'inactive' ? 'bg-gradient-to-r from-gray-800 to-gray-700 dark:from-gray-700 dark:to-gray-600 text-white shadow-[0_0_10px_rgba(75,85,99,0.3)]' : 'bg-white/70 dark:bg-gray-800/70 text-gray-700 dark:text-gray-300 backdrop-blur-sm'}`} onClick={() => setBoostFilter('inactive')} data-id="element-23456">
            Inactive
          </button>
        </div>}
      {/* Grid of items */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4" data-id="element-23457">
        {getFilteredItems().map(item => <div key={item.id} className={`relative bg-white/80 dark:bg-gray-800/80 rounded-lg shadow-sm border border-gray-200/50 dark:border-gray-700/50 backdrop-blur-sm overflow-hidden transition-all duration-300 group hover:shadow-[0_0_15px_rgba(168,85,247,0.2)] ${item.status === 'not_owned' || item.status === 'locked' ? 'opacity-75' : ''}`} data-id="element-23458">
            {getStatusBadge(item)}
            {item.thumbnail ? <div className="aspect-square overflow-hidden relative" data-id="element-23459">
                {/* Item glow effect */}
                <div className={`absolute inset-0 z-10 shadow-[inset_0_0_20px_rgba(0,0,0,0.2)] dark:shadow-[inset_0_0_20px_rgba(0,0,0,0.4)] pointer-events-none ${item.status === 'owned' || item.status === 'equipped' ? 'group-hover:shadow-[inset_0_0_30px_rgba(168,85,247,0.3)]' : ''} transition-all duration-300`} data-id="element-23460"></div>
                <img src={item.thumbnail} alt={item.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-23461" />
                {item.rarity && item.type === 'skin' && <div className={`absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-r ${getRarityColor(item.rarity)} opacity-80 backdrop-blur-sm`} data-id="element-23462"></div>}
                {/* Floating particles for owned/equipped items */}
                {(item.status === 'owned' || item.status === 'equipped') && <div className="absolute inset-0 pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-23463">
                    {Array.from({
              length: 5
            }).map((_, i) => <div key={`particle-${i}`} className="absolute w-1 h-1 rounded-full bg-white/80 animate-float-particle" style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 2}s`,
              animationDuration: `${Math.random() * 3 + 2}s`
            }} data-id="element-23464"></div>)}
                  </div>}
              </div> : <div className={`aspect-square flex items-center justify-center bg-gradient-to-br ${item.type === 'boost' ? 'from-blue-500 to-cyan-600' : item.type === 'fanclub' ? 'from-pink-500 to-red-600' : 'from-purple-500 to-pink-600'} relative overflow-hidden`} data-id="element-23465">
                {/* Background pattern */}
                <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/diamond-upholstery.png')] opacity-20" data-id="element-23466"></div>
                {/* Icon glow effect */}
                <div className="relative z-10 transform group-hover:scale-110 transition-transform duration-300" data-id="element-23467">
                  {item.type === 'boost' && <Flame size={40} className="text-white drop-shadow-[0_0_10px_rgba(255,255,255,0.5)]" data-id="element-23468" />}
                  {item.type === 'fanclub' && <Heart size={40} className="text-white drop-shadow-[0_0_10px_rgba(255,255,255,0.5)]" data-id="element-23469" />}
                  {item.type === 'content' && <Play size={40} className="text-white drop-shadow-[0_0_10px_rgba(255,255,255,0.5)]" data-id="element-23470" />}
                </div>
                {/* Animated energy for the icon */}
                <div className="absolute inset-0 bg-white/20 opacity-0 group-hover:opacity-100 transition-all duration-700 transform rotate-0 group-hover:rotate-180" data-id="element-23471"></div>
              </div>}
            <div className="p-3 relative z-10" data-id="element-23472">
              <div className="flex items-start justify-between" data-id="element-23473">
                <div data-id="element-23474">
                  <h3 className="font-medium text-sm" data-id="element-23475">{item.title}</h3>
                  {item.angelName && <p className="text-xs text-gray-600 dark:text-gray-400" data-id="element-23476">
                      {item.angelName}
                    </p>}
                  {item.description && <p className="text-xs text-gray-600 dark:text-gray-400 mt-1" data-id="element-23477">
                      {item.description}
                    </p>}
                  {item.duration && <p className="text-xs text-gray-600 dark:text-gray-400 mt-1" data-id="element-23478">
                      Duration: {item.duration}
                    </p>}
                </div>
                {item.rarity && <span className={`text-xs font-medium ${getRarityTextColor(item.rarity)}`} data-id="element-23479">
                    {item.rarity.toUpperCase()}
                  </span>}
              </div>
              {getActionButton(item)}
            </div>
          </div>)}
      </div>
      {getFilteredItems().length === 0 && <div className="relative bg-white/80 dark:bg-gray-800/80 rounded-xl p-6 text-center shadow-sm backdrop-blur-sm border border-gray-200/50 dark:border-gray-700/50 overflow-hidden" data-id="element-23480">
          {/* Background pattern */}
          <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/subtle-white-feathers.png')] opacity-5 dark:opacity-10" data-id="element-23481"></div>
          <div className="relative z-10" data-id="element-23482">
            <div className="w-16 h-16 mx-auto mb-4 bg-gray-100 dark:bg-gray-700 rounded-full flex items-center justify-center shadow-[0_0_15px_rgba(156,163,175,0.3)] dark:shadow-[0_0_15px_rgba(156,163,175,0.2)]" data-id="element-23483">
              {activeCategory === 'skins' && <Sparkles className="text-gray-400" size={28} data-id="element-23484" />}
              {activeCategory === 'boosts' && <Flame className="text-gray-400" size={28} data-id="element-23485" />}
              {activeCategory === 'fanclub' && <Heart className="text-gray-400" size={28} data-id="element-23486" />}
              {activeCategory === 'content' && <Play className="text-gray-400" size={28} data-id="element-23487" />}
            </div>
            <h3 className="text-lg font-semibold mb-2" data-id="element-23488">No items found</h3>
            <p className="text-gray-600 dark:text-gray-400 mb-4" data-id="element-23489">
              {activeCategory === 'skins' ? "You don't have any skins matching this filter." : activeCategory === 'boosts' ? "You don't have any active boosts right now." : activeCategory === 'fanclub' ? "You haven't joined any fan clubs yet." : "You don't have any premium content yet."}
            </p>
            <button className="relative px-4 py-2 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-lg text-sm font-medium hover:shadow-[0_0_15px_rgba(168,85,247,0.5)] transition-all overflow-hidden group" data-id="element-23490">
              {/* Button hover effect */}
              <div className="absolute inset-0 bg-white/20 opacity-0 group-hover:opacity-100 transform translate-x-full group-hover:translate-x-0 transition-all duration-500" data-id="element-23491"></div>
              <span className="relative z-10" data-id="element-23492">
                {activeCategory === 'skins' ? 'Browse Skins' : activeCategory === 'boosts' ? 'Get Boosts' : activeCategory === 'fanclub' ? 'Discover Fan Clubs' : 'Browse Content'}
              </span>
            </button>
          </div>
        </div>}
    </div>;
};